import { render, staticRenderFns } from "./Colaborator.vue?vue&type=template&id=1e8cb99f"
import script from "./Colaborator.vue?vue&type=script&lang=js"
export * from "./Colaborator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../shieldgo-admin-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports